import*as i from"antd/lib/notification";import o from"antd/lib/notification";var t=o,a=i;export{t as notification,a as notificationApi};
